import { render, staticRenderFns } from "./AssessmentsListingBody.vue?vue&type=template&id=3fe8df38&scoped=true"
import script from "./AssessmentsListingBody.vue?vue&type=script&lang=ts"
export * from "./AssessmentsListingBody.vue?vue&type=script&lang=ts"
import style0 from "./AssessmentsListingBody.vue?vue&type=style&index=0&id=3fe8df38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe8df38",
  null
  
)

export default component.exports